import { ReactNode } from "react";
import { MosaicTrafficLightClass } from "../traffic-lights/MosaicTrafficLightClass";
import { AitLocationBodyRow } from "./functions/interface";
import { trGetPositionFromLocation } from "./functions/trGetPositionFromLocation";
import { useTableContext } from "./TableContextProvider";

interface AitRowTrafficLightProps {
  location: AitLocationBodyRow;
}

/**
 * Render a traffic light element for a row when applicable.
 *
 * @template T - Row payload type
 * @param props - Component props
 * @param props.location - The row location
 */
export const AitRowTrafficLight = <T,>({ location }: AitRowTrafficLightProps): ReactNode => {
  const { state } = useTableContext<T>();
  const thisRow = trGetPositionFromLocation(state, location, true).data;

  const coreTrafficLight =
    thisRow?.coreTrafficLight ??
    // istanbul ignore next
    "BlankNotEvaluated";

  return !state?.noTrafficLights && coreTrafficLight !== "BlankNotEvaluated"
    ? new MosaicTrafficLightClass(coreTrafficLight, "4px", "-16px").element
    : null;
};

AitRowTrafficLight.displayName = "AitRowTrafficLight";
